export function activePage() {
  let headerLinks = document.querySelectorAll('header a');
  for (let headerLink of headerLinks) {
    headerLink.classList.remove('header-link-active');
    headerLink.classList.remove('header-sublink-active');
    headerLink.removeAttribute('aria-current');

    const linkUrl = new URL(headerLink.href, window.location.href);
    const currentUrl = new URL(window.location.href);
    const normalizePath = path => path.replace(/\/+$/, '') || '/';
    const isCurrent = linkUrl.origin === currentUrl.origin &&
      normalizePath(linkUrl.pathname) === normalizePath(currentUrl.pathname) &&
      linkUrl.search === currentUrl.search;

    if (isCurrent) {
      headerLink.setAttribute('aria-current', 'page');
      if (headerLink.classList.contains('header-sublink')) {
        headerLink.classList.add('header-sublink-active');
        headerLink.closest('.menu-item')?.querySelector('.header-link')?.classList.add('header-link-active');
      } else {
        headerLink.classList.add('header-link-active');
      }
    }
  }
}
